// extracted by mini-css-extract-plugin
export default {"title":"PageHeader_title__nu8Bc","icon":"PageHeader_icon__nHeEN","actions":"PageHeader_actions__hp2Nq"};